module.exports = __webpack_public_path__ + "static/media/video-thumb.90fdb89f.webp";